import { render, staticRenderFns } from "./usersShouxin.vue?vue&type=template&id=5e44510f&scoped=true"
import script from "./usersShouxin.vue?vue&type=script&lang=js"
export * from "./usersShouxin.vue?vue&type=script&lang=js"
import style0 from "./usersShouxin.vue?vue&type=style&index=0&id=5e44510f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e44510f",
  null
  
)

export default component.exports